import { atom } from "recoil";
import { IPart } from "../model/Part";
 
 
export const partsState = atom<IPart[]>({
	key: "partsState",
	default: undefined
});
